export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/containers/index.ts